import React, { useState } from "react";

import { generateNewOrderForm } from "./generateForm";

const OrderProcessForm = ({ onClick  }) => {

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [zip, setZip] = useState("");
  const [brandId, setBrandId] = useState("");
  
  return (
    <div
      className="search-form-box"
      style={{
        background: "#1137535e",
        padding: "1rem",
        borderRadius: "10px",
      }}
    >
      {generateNewOrderForm(
        email,
        setEmail,
        firstName,
        setFirstName,
        lastName,
        setLastName,
        brandId,
        setBrandId,
        zip,
        setZip,
      )}
      <button
        onClick={() =>
          onClick(
            email,
            firstName,
            lastName,
            zip,
            brandId
          )
        }
        className="subBtn"
      >
        <span>Submit</span>
      </button>
      
    </div>
  );
};

export default OrderProcessForm;
